import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {  
}
const qsAll = {
  sections: 'data-section-type="hero"',
}

const initSwiper = (section) => {
  const mainSwiper = new Swiper(section, {
    speed: 500,
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
  mainSwiper.slideTo(1)
  setTimeout(() => {
    mainSwiper.slideTo(0)
  }, 50)
}

export const setupHeros = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSwiper(section))
}